import AccountHolderView from "./account-holder/components/account-holder-view";
import AccountHolderSettingsView from "./account-holder/components/settings/settings-view";
import AccountHolderActive from "./account-holder/components/account-holder-active/account-holder-active-view";
import AccountHolderCompleted from "./account-holder/components/account-holder-completed/account-holder-completed-view";
import AccountHolderCanceled from "./account-holder/components/account-holder-canceled/account-holder-canceled-view";
import HomeView from "./security/components/home-view";
import AccessDeniedView from "./security/components/access-denied";
import PrivacyPolicyView from "./admin/components/privacy-policy/privacy-policy-view";
import AccountHolderEmailVerification
  from './account-holder/components/account-holder-email-verification/account-holder-email-verification';
import PaymentHubView from '@finpay-development/shared-platform/lib/esm/payment-hub/components/payment-hub-view';
import MobilePaymentProgramView from '@finpay-development/shared-platform/lib/esm/payment-hub/components/mobile-payment-program-view';
import MobileNoPaymentProgramsView from '@finpay-development/shared-platform/lib/esm/payment-hub/components/mobile-no-payment-programs-view';
import PatientHubView from '@finpay-development/shared-platform/lib/esm/payment-hub/components/patient-hub-view';

export interface RouteConfigProps {
  path: string;
  protectedPageName?: string;
  component: any;
}

const RouteConfiguration: Array<RouteConfigProps> = [
  { path: "/", component: HomeView },

  // Account Holder
  {
    path: "/patient",
    protectedPageName: "Patient Dashboard",
    component: AccountHolderView,
  },
  {
    path: "/patient/settings",
    protectedPageName: "Patient Dashboard",
    component: AccountHolderSettingsView,
  },
  {
    path: "/patient/dashboard",
    protectedPageName: "Patient Dashboard",
    component: AccountHolderView,
  },
  {
    path: "/patient/dashboard/active",
    protectedPageName: "Patient Dashboard",
    component: AccountHolderActive,
  },
  {
    path: "/patient/dashboard/completed",
    protectedPageName: "Patient Dashboard",
    component: AccountHolderCompleted,
  },
  {
    path: "/patient/dashboard/canceled",
    protectedPageName: "Patient Dashboard",
    component: AccountHolderCanceled,
  },
  {
    path: "/patient/encounter/:encounterId/email-verification",
    protectedPageName: "Patient Dashboard",
    component: AccountHolderEmailVerification
  },

  //access-denied
  { path: "/accessdenied", component: AccessDeniedView },

  // Misc
  { path: "/privacypolicy", component: PrivacyPolicyView },

  // Payment Hub - Mobile routes
  {
    path: "/mobile",
    protectedPageName: "Payment Hub",
    component: PatientHubView,
  },
  {
    path: "/mobile/patient/:patientId/ioc/:patientEncounterId",
    protectedPageName: "Payment Hub",
    component: PatientHubView,
  },
  {
    path: "/mobile/patient/:patientId",
    protectedPageName: "Payment Hub",
    component: PatientHubView,
  },
  {
    path: "/mobile/patient/:patientId/ioc/:patientEncounterId/no-payment-programs",
    component: MobileNoPaymentProgramsView,
  },
  {
    path: "/mobile/patient/:patientId/ioc/:patientEncounterId/program/custom-results",
    component: MobilePaymentProgramView,
  },
  {
    path: "/mobile/patient/:patientId/ioc/:patientEncounterId/program/:programType",
    component: MobilePaymentProgramView,
  },
  {
    path: "/mobile/patient/:patientId/ioc/:patientEncounterId/program",
    component: MobilePaymentProgramView,
  },
  {
    path: "/mobile/patient/:patientId/ioc/:patientEncounterId/pay",
    component: PaymentHubView,
  },
  // {
  //   path: "/hub/patient/:patientId/ioc/:patientEncounterId/program/custom-results",
  //   protectedPageName: "Payment Hub",
  //   component: PaymentProgramView,
  // },
  // {
  //   path: "/hub/patient/:patientId/ioc/:patientEncounterId/program/:programType",
  //   protectedPageName: "Payment Hub",
  //   component: PaymentProgramView,
  // },
  // {
  //   path: "/hub/patient/:patientId/ioc/:patientEncounterId/program",
  //   protectedPageName: "Payment Hub",
  //   component: PaymentProgramView,
  // },
  // {
  //   path: "/hub/patient/:patientId/ioc/:patientEncounterId/pay",
  //   protectedPageName: "Payment Hub",
  //   component: PaymentHubView,
  // },
  // {
  //   path: "/hub/patient/:patientId/ioc/:patientEncounterId/pay/change-recurring",
  //   protectedPageName: "Payment Hub",
  //   component: RecurringPaymentMethodView,
  // },
  // {
  //   path: "/hub/patient/:patientId/ioc/:patientEncounterId",
  //   protectedPageName: "Payment Hub",
  //   component: HubView,
  // },
  // {
  //   path: "/hub/patient/:patientId",
  //   protectedPageName: "Payment Hub",
  //   component: HubView,
  // },
  // {
  //   path: "/hub/patient",
  //   protectedPageName: "Payment Hub",
  //   component: NewPatientView,
  // },
  // {
  //   path: "/hub",
  //   protectedPageName: "Payment Hub",
  //   component: HubView,
  // },

];

export default RouteConfiguration;
